import { Option } from '../../interfaces/ProyectosDTOS/Option'

export interface DoctoradosVigenciaDTO{
    idPrograma: number,
    nombrePrograma: string,
    esVigente: string
}

export function VoidDoctoradosVigenciaDTO(): DoctoradosVigenciaDTO{
    return{
        idPrograma: 0,
        nombrePrograma: '',
        esVigente: 'N'
    }    
}

export function CastDoctoradosVigenciaDTOtoOption(docto: DoctoradosVigenciaDTO): Option{
    return{
        value: docto.idPrograma,
        label: docto.nombrePrograma
    }    
}

export function CastListDoctoradosVigenciaDTOtoListOption(doctos: Array<DoctoradosVigenciaDTO>): Array<Option>{
    let resp: Array<Option> = []
    doctos.forEach(element => {
     let d = CastDoctoradosVigenciaDTOtoOption(element);
     resp.push(d);   
    });
    return resp
}